import { STEPS } from "../../workflow/steps";

export function handleMapClick({ e, workflowStepRef, tools, mapMode }) {
  if (mapMode === "view") return; // in view mode, ignore clicks

  const step = workflowStepRef.current;

  switch (step) {
    case STEPS.DRAW_FIELD_RECTANGLE:
      tools.fieldTool.onClick(e.lngLat);
      break;
    case STEPS.DRAW_MASTS_RECTANGLE:
      tools.mastTool.onClick(e.lngLat);
      break;
    case STEPS.EDIT_MAST_POINTS:
      tools.pointTool.onClick(e.lngLat);
      break;
    case STEPS.DRAW_BUILDINGS:
      tools.polylineTool.onClick(e.lngLat);
      break;
    default:
      break;
  }
}

export function handleMapMouseMove({ e, workflowStepRef, tools, mapMode }) {
  if (mapMode === "view") return;

  const step = workflowStepRef.current;

  switch (step) {
    case STEPS.DRAW_FIELD_RECTANGLE:
      tools.fieldTool.onMouseMove(e.lngLat);
      tools.fieldTool.map.getCanvas().style.cursor = "crosshair";
      break;
    case STEPS.DRAW_MASTS_RECTANGLE:
      tools.mastTool.onMouseMove(e.lngLat);
      tools.fieldTool.map.getCanvas().style.cursor = "crosshair";
      break;
    case STEPS.EDIT_MAST_POINTS:
      tools.pointTool.onMouseMove(e.lngLat);
      tools.fieldTool.map.getCanvas().style.cursor = "grab";
      break;
    case STEPS.DRAW_BUILDINGS:
      tools.polylineTool.onMouseMove(e.lngLat);
      tools.fieldTool.map.getCanvas().style.cursor = "crosshair";
      break;
    default:
      Object.values(tools).forEach(tool => {if (tool?.map?.getCanvas) tool.map.getCanvas().style.cursor = "default";});
      break;
  }
}

export function activateCurrentTool(tools, workflowStep) {
  switch (workflowStep) {
    case STEPS.DRAW_FIELD_RECTANGLE:
      tools.fieldTool?.clearPreviews();
      break;
    case STEPS.DRAW_MASTS_RECTANGLE:
      tools.mastTool?.clearPreviews();
      break;
    case STEPS.DRAW_BUILDINGS:
      tools.polylineTool?.finishCurrentLine();
      break;
    case STEPS.EDIT_MAST_POINTS:
      // pointTool is always ready
      break;
    default:
      break;
  }
}

// ── Undo-Dispatch (Signify-Feedback Dennis 03.07.2026) ──────────────
// Leitet "Rückgängig" ans Werkzeug des aktiven Zeichen-Schritts weiter —
// gleiche Zuordnung wie handleMapClick oben. Gibt true zurück, wenn
// etwas zurückgenommen wurde.
export function handleUndo({ workflowStepRef, tools }) {
  switch (workflowStepRef.current) {
    case STEPS.DRAW_FIELD_RECTANGLE:
      return tools.fieldTool?.undoLastPoint() || false;
    case STEPS.DRAW_MASTS_RECTANGLE:
      return tools.mastTool?.undoLastPoint() || false;
    case STEPS.EDIT_MAST_POINTS:
      return tools.pointTool?.undo() || false;
    case STEPS.DRAW_BUILDINGS:
      return tools.polylineTool?.undo() || false;
    default:
      return false;
  }
}

export function resetAllTools(tools) {
  tools.fieldTool?.clearPreviews();
  tools.mastTool?.clearPreviews();
  tools.pointTool?.reset();
  tools.polylineTool?.finishCurrentLine();
}